/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Form as FormUi,
  Input,
  Checkbox,
  Dropdown,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import { MyNormalInput } from "../dynamicComponent/myInputs";
import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";
import CreateAxios from "../axiosComponent/create";
import { connect } from "react-redux";
import MandatoryMark from "../common/mandatorymark";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { MyInput } from "../dynamicComponent/myInputs";
import { DateData } from "../dynamicComponent/datepick";
import { translate } from "react-i18next";
import moment from "moment";

const ModalReject = ({
  values,
  touched,
  errors,
  isSubmitting,
  handleSubmit,
  setFieldValue,
  t,
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [Vendors, setVendors] = useState([]);
  const [VendorsGroup, setVendorsGroup] = useState([]);
  var vendorIndex = 0;

  useEffect(() => {
    getAllVendors();
    // console.log(props);
  }, []);
  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
    // if (values.vendor) handleSubmit();
  };

  const handleSubmited = () => {
    if (values.pull_rates == 1 && values.base_rate && values.uom) {
      if (values.allVendors.length > 0) {
        handleSubmit();
        setmodalOpen(false);
      }
      // handleSubmit();
      // setmodalOpen(false);
    } else if (values.pull_rates == 0) {
      if (values.allVendors.length > 0) {
        handleSubmit();
        setmodalOpen(false);
      }
    }
  };

  const getAllVendors = () => {
    ReadAxios({ url: `transporterMaster` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVendors([])
          : setVendorsState(res.data.resultSet);
        getAllVendorsGroup();
      })
      .catch((err) => setVendors([]));
  };

  const getAllVendorsGroup = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/group`,
    })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVendorsGroup([])
          : setVendorsGroupState(res.data.resultSet);
      })
      .catch((err) => setVendors([]));
  };

  const setVendorsState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.transporterName,
        key: item.transporterCode,
        value: vendorIndex++,
      };
    });
    setVendors(result);
  };

  const setVendorsGroupState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.vendorGroupName,
        key: item.vendorGroupId,
        value: vendorIndex++,
      };
    });
    setVendorsGroup(result);
  };


  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        size="mini"
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            size="mini"
            color="red"
            className="m-2 w3-hover-red"
            circular
          >
            {t("reject") || "Reject"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          <div className="d-flex justify-content-between">
            <label className="font-weight-normal">{t("reject") || "Reject"}</label>
            <div className="form-inline">
              <i onClick={handleClose} className="fas fa-times"></i>
            </div>
          </div>
        </Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description style={{ height: "12em" }}>
            <div className="ui form">
              <Fieldmik
                name="rejection_reason"
                className="form-control"
                component="textarea"
                placeholder='Enter Reason' />
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            type="submit"
            onClick={handleSubmited}
            disabled={isSubmitting || values.rejection_reason ? false : true}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("action_button.submit") || "Submit"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
// TODO: validation
const FormikReject = withFormik({
  validationSchema: yup.object({
    pull_rates: yup.boolean().optional(),
    base_rate: yup.number().when('pull_rates', {
      is: (value) => value,
      then: yup.number().required('Required').nullable(), otherwise: yup.number().optional().nullable()
    }),
    uom: yup.string().when('pull_rates', {
      is: (value) => value,
      then: yup.string().required('Required').nullable(), otherwise: yup.string().optional().nullable()
    }),
  }),
  mapPropsToValues: (props) => {
    return {
      allVendors: [],
      vendors: [],
      vendor_groups: [],
      broadcast_start_datetime: new Date(),
      broadcast_end_datetime: moment(new Date()).add(120, 'm').toDate(),
      // shipment_id: +props.shipmentId,
      pull_rates: 0,
      email: 0,
      sms: 0,
      mobile: 0,
      base_rate: null,
      uom: null,
      return_load: 0,
    };
  },
  handleSubmit(values, { setSubmitting, props }) {
    if (values.allVendors.length > 0) {
      for (let index = 0; index < props.orders.length; index++) {
        const element = props.orders[index].vendor_order_id;
        const shipment_id = props.orders[index].shipment.vendor_shipment_id;
        let broadcast_start_datetime = moment(values.broadcast_start_datetime).format('YYYY-MM-DD HH:mm:ss');
        let broadcast_end_datetime = moment(values.broadcast_end_datetime).format('YYYY-MM-DD HH:mm:ss');
        CreateAxios({
          completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${element}/broadcast`,
          payload: { ...values, shipment_id, broadcast_start_datetime, broadcast_end_datetime },
        })
          // Promise.all([props.orders])
          .then((res) => {
            setSubmitting(false);
            props.successAlertDispatcher({
              type: "success",
              messageHeader: "Success",
              messageBody: res.data.message,
            });
            // props.reFetchOrder();
            window.location.reload()
          })
          .catch((err) => {
            props.successAlertDispatcher({
              type: "error",
              messageHeader: "Error",
              messageBody: err.message,
            });
          });
      }
    } else {
      props.successAlertDispatcher({
        type: "success",
        messageHeader: "Success",
        messageBody: "Please Select Vendor",
      });
    }

  },
})(ModalReject);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("allot")(FormikReject)
);
